/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Summary_AcInputs */

const en_pc_cmp_summary_ac = /** @type {(inputs: Pc_Cmp_Summary_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best for editing existing text, Office conversion, e-signature workflows, multilingual OCR and enterprise rollouts.`)
};

const zh_pc_cmp_summary_ac = /** @type {(inputs: Pc_Cmp_Summary_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最适合编辑已有文字、Office 转换、电子签名流程、多语言 OCR 和企业部署。`)
};

/**
* | output |
* | --- |
* | "Best for editing existing text, Office conversion, e-signature workflows, multilingual OCR and enterprise rollouts." |
*
* @param {Pc_Cmp_Summary_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_summary_ac = /** @type {((inputs?: Pc_Cmp_Summary_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Summary_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_summary_ac(inputs)
	return zh_pc_cmp_summary_ac(inputs)
});
export { pc_cmp_summary_ac as "pc.cmp.summary_ac" }